import { postData } from "./axiosConfig";

export const userLogin = async (body) => {
    return await postData("/auth/login", body)
}

export const userSignUp = async (body) => {
    return await postData("/auth/register", body)
}

export const forgotPassword = async (body) => {
    return await postData("/auth/forgot-password", body)
}

export const otpVerification = async (body) => {
    return await postData("/auth/verification", body)
}
export const resetPassword = async (body) => {
    return await postData("/auth/reset-password", body)
}

